import ContentHeader from '@Components/ContentHeader/index'
import React from 'react'
import { SongwriterSubmissionSuggestion } from '@Entities/rightsholder/songwriter-submission-suggestion'
import type { WorkModel } from '@Entities/work/work'
import BackButton from '@App/kit/components/Buttons/BackButton'
import { tableCellSanitizer } from '@App/helpers/table-cell-sanitizer'
import ChangeRequestViewActions from '@Scenes/RightsholderScene/ChangeRequests/View/ChangeRequestViewActions/index'
import formatRequestDate from '@Scenes/RightsholderScene/ChangeRequests/format-request-date'

interface ChangeRequestViewHeaderProps {
    rightsholderId: number
    suggestion: SongwriterSubmissionSuggestion
    work: WorkModel
    updateStatus: (status: 'APPROVED' | 'DISMISSED') => void
}

const ChangeRequestViewHeader = ({ suggestion, work, rightsholderId, updateStatus }: ChangeRequestViewHeaderProps) => (
    <ContentHeader
        title=""
        content={
            <>
                <BackButton />
                <div className="request-summary">
                    <div>
                        <div>Request For:</div>
                        <strong>Update Shares</strong>
                    </div>
                    <div>
                        <div>Request Date</div>
                        <strong>{formatRequestDate(suggestion.createdAt)}</strong>
                    </div>
                    <div>
                        <div>Work</div>
                        <strong>{work.title}</strong>
                    </div>
                    <div>
                        <div>MLC Song Code</div>
                        <strong>{tableCellSanitizer(work.songCode)}</strong>
                    </div>
                    <div>
                        <div>Requested By</div>
                        <strong>{tableCellSanitizer(suggestion.songwriterName)}</strong>
                    </div>
                </div>
                {suggestion.status === 'SUBMITTED' && (
                    <ChangeRequestViewActions
                        rightsholderId={rightsholderId}
                        submissionId={Number(suggestion.submissionId)}
                        updateStatus={updateStatus}
                    />
                )}
            </>
        }
    />
)

export default ChangeRequestViewHeader
